const INITIAL_STATE = {
  dailyLoadsList: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SET_DAILY_SHIPMENTS': {
      return { ...state, dailyLoadsList: action.dailyLoads };
    }
    default:
      return state;
  }
};
